import React from "react";
import { useSelector } from "react-redux";
import { schedule } from "../../utils/helpers/functions";
import moment from "moment";

const PaymentSchedule = ({ history }) => {
  const { customer_policy_details, policy_history_details } = useSelector(
    (state) => state?.policy
  );

  const data = history ? policy_history_details : customer_policy_details;

  const paymentSchedule = schedule(
    data?.policy_app_details?.effectiveDate,
    data?.policy_app_details?.endDate,
    data?.policy_app_details?.repayment_frequency,
    data?.policy_app_details?.totalPremium,
    data?.payment_details
  );

  const totals = paymentSchedule?.reduce(
    (accumulator, item) => {
      accumulator.total_outstanding += item.total_outstanding;
      accumulator.total_actual_payment += item.actual_payment;
      accumulator.total_amount += item.amount;
      return accumulator;
    },
    { total_outstanding: 0, total_actual_payment: 0, total_amount: 0 }
  );

  return (
    <div className='table-responsive'>
      <table class='table'>
        <thead class='' style={{ background: "#727Cf5", color: " #fff" }}>
          <tr>
            <th scope='col'>Expected Date</th>
            <th scope='col'>Payment Date</th>
            <th scope='col'>Premium</th>
            <th scope='col'>Actual Payment</th>
            <th scope='col'>Total Outstanding</th>
          </tr>
        </thead>
        <tbody>
          {paymentSchedule?.map((item, i) => (
            <tr key={i}>
              {/* <td>{i + 1}</td> */}
              <td scope='row'>{moment(item?.expected_date).format("D-M-Y")}</td>
              <td>
                {item?.payment_date &&
                  moment(item?.payment_date).format("D-M-Y")}
              </td>
              <td>{item?.amount?.toFixed(2)}</td>
              <td>{item?.actual_payment?.toFixed(2)}</td>
              <td>{item?.total_outstanding?.toFixed(2)}</td>
            </tr>
          ))}
          <tr>
            <td className='fw-bold'>Total</td>
            <td className='fw-bold'></td>
            <td className='fw-bold'>{totals?.total_amount.toFixed(2)}</td>
            <td className='fw-bold'>
              {totals?.total_actual_payment.toFixed(2)}
            </td>
            <td className='fw-bold'>{totals?.total_outstanding.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PaymentSchedule;
